import React, { createContext, useState, useContext, useEffect } from "react";
import OktaAuth from "@okta/okta-auth-js";
import { Decryption, Encryption } from "../lib/Decryption";
import { isUnmanagedOrg } from "../lib/hosts";

const OktaConfigContext = createContext();

export const useOktaConfig = () => useContext(OktaConfigContext);

export const OktaConfigProvider = ({ children }) => {
  const [oktaConfig, setOktaConfig] = useState(() => {
    // Initialize with localStorage to prevent setting state within the effect.
    const storedCredentials = localStorage.getItem("_Id");
    const decryptData = Decryption(storedCredentials);
    return decryptData || {};
  });


  const [oktaAuths, setOktaAuths] = useState(null);

  const [loginToken, setLoginToken] = useState(() => {
    try {
      const firebaseAuth = localStorage.getItem("Firebase Auth");

      const oktaAuth = localStorage.getItem("okta-token-storage");

      // Safely parse Firebase token (if available)
      const firebaseToken = JSON.parse(firebaseAuth)?.accessToken;


      // Safely parse Okta token and get the access token
      const oktaToken = oktaAuth ? JSON.parse(oktaAuth)?.accessToken?.accessToken : null;

      // Prioritize Firebase token, otherwise use Okta token
      return firebaseToken || oktaToken || null;
    } catch (error) {
      return null;
    }
  });


  useEffect(() => {


    if (oktaConfig && oktaConfig.clientId && oktaConfig.issuer) {
      const authClient = new OktaAuth(oktaConfig);


      // Store credentials in localStorage only if they change meaningfully.
      if (
        !localStorage.getItem("_Id") ||
        localStorage.getItem("_Id") !== JSON.stringify(oktaConfig)
      ) {
        const encryptData = Encryption(JSON.stringify(oktaConfig));
        localStorage.setItem("_Id", encryptData);
      }
      setOktaAuths(authClient);
    }
  }, [oktaConfig]);


  const namePrefixFunc = () => (isUnmanagedOrg() ? "" : "pirm_addon__");

  function getDynamicField(item, suffix) {
    const pirmPrifix = namePrefixFunc();
    const fullName = `${pirmPrifix}${suffix}`;
    return item[fullName];
  }
  // Return a context value even if oktaAuths is null to prevent undefined errors
  const value = { oktaAuths, setOktaConfig, oktaConfig, loginToken, setLoginToken, getDynamicField };

  return (
    <OktaConfigContext.Provider value={value}>
      {children}
    </OktaConfigContext.Provider>
  );
};
